// Shared helpers for event list/card/table views (Dashboard, EventsPage).

export const getEventStatus = (event) => {
    const now = new Date();
    const start = event.start_date ? new Date(event.start_date) : null;
    const end = event.end_date ? new Date(event.end_date) : null;
    if (end && now > end) return { label: 'Ended', color: 'ended' };
    if (start && now < start) return { label: 'Upcoming', color: 'upcoming' };
    return { label: 'Active', color: 'active' };
};
